import { dataToolsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconToolsSolid = /*#__PURE__*/createIcon(dataToolsSolid)
export default IconToolsSolid
